// see http://jsfiddle.net/ctesene/9f2rA/5/light/
export default angular.module('selectAllCheckbox', [])
  .directive('selectAllCheckbox', function () {
    return {
      replace: true,
      restrict: 'E',
      scope: {
        checkboxes: '=',
        allselected: '=allSelected',
        allclear: '=allClear'
      },
      template: `
      <div class="c-check">
        <input type="checkbox" ng-model="master" ng-change="masterChange()" id="checkbox-{{$id}}" class="c-check__input">
        <label for="checkbox-{{$id}}" class="c-check__label">
          <span class="c-check__box">
            <span gg-icon="icon-checkmark" class="c-check__mark"></span>
          </span>
          <span class="c-check__text" ng-transclude ng-if="hasTranscluded"></span>
        </label>
      </div>`,
      controller: function ($scope, $element) {
        $scope.masterChange = function () {
          if ($scope.master) {
            $scope.checkboxes.forEach(cb => cb.selected = true);
          } else {
            $scope.checkboxes.forEach(cb => cb.selected = false);
          }
        };

        $scope.$watch('checkboxes', function () {
          $scope.master = !!$scope.checkboxes.filter(cb => cb.selected).length;
        }, true);
      }
    };
  })



/** WEBPACK FOOTER **
 ** ./src/directives/selectAllCheckbox.js
 **/